import { filter } from 'rxjs/operators';
import { MacrotemaFaq, CategoriaFaq, SottoCategoriaFaq, Faq, ParolaChiave } from '@hm_app/@core/models/info';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash-es';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'gerarchia-faq',
    templateUrl: './gerarchia-faq.component.html',
    styleUrls: ['./gerarchia-faq.component.scss'],
})
export class GerarchiaFaqComponent implements OnInit {

    _macrotemi: MacrotemaFaq[];
    _categorie: CategoriaFaq[];
    _sottocategorie: SottoCategoriaFaq[];
    _sottocategorie_filtered: SottoCategoriaFaq[];
    _parole_chiave: ParolaChiave[];

    _faqs: Faq[];
    @Input() set faqs(faqs: Faq[]) {
        this._faqs = faqs;
        this.refreshStructure();
    }


    get faqs(): Faq[] {
        return this._faqs;
    }

    filtered_faqs: Faq[];

    _current_macrotema: MacrotemaFaq;
    categorie_selected: CategoriaFaq[];

    sotto_categorie_open: boolean;
    _current_categoria: CategoriaFaq;
    _current_sottocategoria: SottoCategoriaFaq;

    @ViewChild('item') accordion;

    getIcon(m: MacrotemaFaq) {
        switch (m.id) {
            case 1:
                return 'assets/images/faq/fetus_giallo.png';
            case 2:
                return 'assets/images/faq/woman_azzuro.png';
            case 3:
                return 'assets/images/faq/baby_verde.png';

        }
    }

    getActiveIcon(m: MacrotemaFaq) {
        switch (m.id) {
            case 1:
                return 'assets/images/faq/fetus_giallo.png';
            case 2:
                return 'assets/images/faq/woman_azzuro.png';
            case 3:
                return 'assets/images/faq/baby_verde.png';

        }
    }

    @Input() set macrotemi(m: MacrotemaFaq[]) {
        this._macrotemi = m;
    }

    get macrotemi(): MacrotemaFaq[] {
        return this._macrotemi;
    }

    @Input() set categorie(c: CategoriaFaq[]) {
        this._categorie = c;
    }

    get categorie(): CategoriaFaq[] {
        return this._categorie;
    }

    @Input() set parole_chiave(p: ParolaChiave[]) {
        this._parole_chiave = p;
    }

    get parole_chiave(): ParolaChiave[] {
        return this._parole_chiave;
    }

    @Input() set sottocategorie(c: SottoCategoriaFaq[]) {
        this._sottocategorie = c;
    }

    get sottocategorie(): SottoCategoriaFaq[] {
        return this._sottocategorie;
    }

    set sottocategorie_filtered(c: SottoCategoriaFaq[]) {
        this._sottocategorie_filtered = c;
    }

    get sottocategorie_filtered(): SottoCategoriaFaq[] {
        return this._sottocategorie_filtered;
    }

    set current_macrotema(cm: MacrotemaFaq) {
        this._current_macrotema = cm;
        this.refreshStructure();
    }

    refreshStructure() {
        this.current_categoria = null;
        this.current_sottocategoria = null;
        this.categorie_selected = [];
        this.sottocategorie_filtered = [];
        if (this.accordion) this.accordion.closeAll();
        this.filtered_faqs = null;
        this.categorie = _.sortBy(this.categorie, 'id');
        if (this.current_macrotema) {
            this.filterCategorieForMacrotema();
        }
        this.filterFaqs();
    }

    private filterCategorieForMacrotema() {
        const filtered = _.filter(this.faqs, { macrotema: this.current_macrotema.id });
        const categs_filtered = new Set<CategoriaFaq>();
        for (const f of filtered) {
            const categoria = _.find(this.categorie, { id: f.categoria });
            categs_filtered.add(categoria);
        }
        this.categorie_selected = [];
        this.categorie_selected = Array.from(categs_filtered);
        this.categorie_selected = _.sortBy(this.categorie_selected, 'id');
    }

    get current_macrotema(): MacrotemaFaq {
        return this._current_macrotema;
    }

    set current_categoria(cc: CategoriaFaq) {
        this._current_categoria = cc;
        this.current_sottocategoria = null;
        if (this._current_categoria) {
            this.sottocategorie_filtered = [];
            const scf = _.filter(this.sottocategorie, { categoria: this._current_categoria.id });
            for (const sc of scf) {
                const ff = _.filter(this.faqs, { macrotema: this.current_macrotema.id, categoria: this.current_categoria.id, sottocategoria: sc.id });
                if (ff && ff.length > 0) {
                    this.sottocategorie_filtered.push(sc);
                }
            }
        }
        this.filterFaqs();
    }

    get current_categoria(): CategoriaFaq {
        return this._current_categoria;
    }

    set current_sottocategoria(csc: SottoCategoriaFaq) {
        this._current_sottocategoria = csc;
        this.filterFaqs();

    }

    get current_sottocategoria(): SottoCategoriaFaq {
        return this._current_sottocategoria;
    }

    filterFaqs() {
        let ff = this.faqs;
        if (this.current_macrotema) {
            ff = _.filter(ff, { macrotema: this.current_macrotema.id });
        }
        if (this.current_categoria) {
            ff = _.filter(ff, { categoria: this.current_categoria.id });

        }
        if (this.current_sottocategoria) {
            ff = _.filter(ff, { sottocategoria: this.current_sottocategoria.id });
            this.filtered_faqs = ff;

        }
        ff = _.sortBy(ff, 'id');
    }

    constructor() { }

    ngOnInit() {
        this.filtered_faqs = this.faqs;
    }

    openOrCloseSottoCategorie(c: CategoriaFaq) {
        this.sotto_categorie_open = !this.sotto_categorie_open;
        if (this.sotto_categorie_open) {
            this.current_categoria = c;
        } else {
            this.current_categoria = null;
        }
    }
}
